export enum SaleStatus {
  Cancelled = 'cancelled',
  Return = 'return',
  Reservation = 'reservation',
  Finalized = 'finalized',
  Pending = 'pending',
  Deleted = 'deleted',
}
